export const initialFilterCriteria = {
    favorite: false,
    planCode: null,
    planType: {
        ino: false,
        incentive: false,
        indemnity: false,
        passive: false
    }
};

export const initialfilterTotalsCache = {};

const initialVisiblePlanFilterTotals = {
    // TBD
}

export const initialState = {
    quickQuoteRequest: {
        groupSize: null,
        zipCode: null,
        zipObj: {},
        effectiveDate: null,
        stateCode: null,
        countyCode: null,
    },
    packages: [],
    isFetchingPlans: false,
    numRateBatchesFetching: 0,
    quickQuotePlansError: null,
    quickQuoteRatesError: null,
    plans: [],
    allPlans:[],
    visiblePlans: [],
    selectedPlans: [],
    favoritedPlans: [],
    selectedPlansMap: {},
    visiblePlanFilterTotals: initialVisiblePlanFilterTotals,
    numRatesFetched: 0,
    allRatesFetched: true,
    filterCriteria: initialFilterCriteria,
    filterTotalsCache: initialfilterTotalsCache,
    specialty: true,
    sortEnabled: true,
    ascending: true,
    showPreferredPlans: true,
    filteredResults:[],
    appliedFilters:{},
    advanceFilterProductType:'life',
    displayLeftSideFilter:false,
    isSendingRateAdjustments: false,
    rateAdjustmentsError: false,
    employeeClassing : {
        classingOpted : false, // when opts for any class from dropdown
        classes : [], // List of opted classes by the user
        selectedClass : '', // Class selected on plan Selection Page
        employeeSelectedClasses: [] // Subset of life classes that have employees tied them on quote census
    },
    classingOptions:["Hourly", "Salaried", "Union", "Non-Union", "Part-Time", "Full-Time", "Management", "Non-Management"],
    classRatesFetched: false,
    isFetchingClassRates: false,
    showDependentLifeComponents: false,
    showSupplementalLifeComponents: false,
    // showSuppDependentLifeComponents:false
};

export const lifeFilterSet = [
    {
        filterGroup:'Plan Code',
        filterId:'plancode',
        planField:'code',
        type:'list',
        place:'dropdown',
        display:false,
        values: {}
    },
    {
        filterGroup:'Contribution Type',
        filterId:'contributionType',
        planField:'fundingType',
        type:'list',
        place:'basic',
        display:true,
        values: {}
    },
    {
        filterGroup:'Benefit Type',
        filterId:'benefitType',
        planField:'benefitDetails.benefitType',
        type:'list',
        place:'basic',
        display:true,
        values: {}
    },
    {
        filterGroup:'Benefit Level',
        filterId:'benefitLevel',
        planField:'benefitAmount',
        type:'list',
        place:'basic',
        display:true,
        values: {}
    },

    {
        filterGroup:'Plan Maximum',
        filterId:'planMaximum',
        planField:'planMax',
        type:'list',
        place:'basic',
        display:true,
        values: {}
    },
    {
        filterGroup:'Installation Options',
        filterId:'primeInstallOption',
        planField:'primeInstallOption',
        type:'list',
        place:'basic',
        display:true,
        values: {}
    }
]
